export const GET_CUSTOMERS_ERROR = "Une erreur est survenue lors du chargement des clients.";
export const GET_CUSTOMER_RESERVATIONS_ERROR = "Une erreur est survenue lors du chargement des réservations du client.";
export const GET_CUSTOMER_DUPLICATES_ERROR = "Une erreur est survenue lors du chargement des doublons.";
export const ADD_CUSTOMER_ERROR = "Une erreur est survenue lors de l'ajout du client.";
export const DELETE_CUSTOMER_ERROR = "Une erreur est survenue lors de la suppression du client.";
export const BULK_DELETE_CUSTOMER_ERROR = "Une erreur est survenue lors de la suppression des clients.";
export const UPDATE_CUSTOMER_ERROR = "Une erreur est survenue lors de la modification du client.";
export const FUSE_CUSTOMERS_ERROR = "Une erreur est survenue lors de la fusion des clients.";



// WEBPACK FOOTER //
// ./src/errors/customers.js